(() => {
  const ACTIVE_ATTR = 'data-active';
  const HIDDEN_ATTR = 'hidden';
  const BOUND_ATTR = 'data-search-megamenu-bound';

  const SELECTORS = {
    trigger: '.search-megamenu-trigger',
    root: '[data-search-megamenu]',
    panel: '[data-search-panel]',
    body: '[data-search-body]',
    input: 'input[type="search"]',
    megaMenuTrigger: '.mega-menu-hover-trigger',
    megaMenuContainer: '.mega-menu-hover-container',
    megaMenuActiveTrigger: '.mega-menu-hover-trigger[data-active="true"]',
  };

  function init() {
    const triggers = Array.from(document.querySelectorAll(SELECTORS.trigger));
    if (triggers.length === 0) return;

    triggers.forEach((trigger) => {
      if (trigger.hasAttribute(BOUND_ATTR)) return;

      const controlledId = trigger.getAttribute('aria-controls');
      const root = controlledId ? document.getElementById(controlledId) : document.querySelector(SELECTORS.root);
      if (!root) return;

      const panel = root.querySelector(SELECTORS.panel) || root.querySelector('.search-megamenu__panel');
      const body = root.querySelector(SELECTORS.body);
      const input = root.querySelector(SELECTORS.input);
      if (!panel) return;

      trigger.setAttribute(BOUND_ATTR, '');
      let isOpen = root.getAttribute(ACTIVE_ATTR) === 'true';
      let lastHeight = 0;

      function setHidden(hidden) {
        if (hidden) root.setAttribute(HIDDEN_ATTR, '');
        else root.removeAttribute(HIDDEN_ATTR);
      }

      function setActive(active) {
        root.setAttribute(ACTIVE_ATTR, active ? 'true' : 'false');
        trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
        isOpen = active;
      }

      function updateHeight() {
        const target = body || panel;
        const next = Math.ceil(target.scrollHeight);
        if (Math.abs(next - lastHeight) <= 1) return;
        lastHeight = next;
        panel.style.setProperty('--search-menu-height', `${next}px`);
      }

      function closeOtherMenus() {
        const megaMenuContainer = document.querySelector(SELECTORS.megaMenuContainer);
        if (megaMenuContainer) megaMenuContainer.setAttribute(ACTIVE_ATTR, 'false');
        document.querySelectorAll(SELECTORS.megaMenuActiveTrigger).forEach((el) => {
          el.setAttribute(ACTIVE_ATTR, 'false');
        });
      }

      function open() {
        setHidden(false);
        setActive(true);
        closeOtherMenus();
        
        // Agregar clase open-search y quitar open-menu del header-wrapper
        const headerWrapper = document.querySelector('.header-wrapper');
        if (headerWrapper) {
          headerWrapper.classList.add('open-search');
          headerWrapper.classList.remove('open-menu');
        }
        
        requestAnimationFrame(() => {
          updateHeight();
          if (input) input.focus();
        });
      }

      function close() {
        setActive(false);
        
        // Quitar clase open-search del header-wrapper
        const headerWrapper = document.querySelector('.header-wrapper');
        if (headerWrapper) {
          headerWrapper.classList.remove('open-search');
        }
        
        window.setTimeout(() => {
          if (root.getAttribute(ACTIVE_ATTR) !== 'true') setHidden(true);
        }, 250);
      }

      function toggle() {
        if (isOpen) close();
        else open();
      }

      // Initial height (in case it opens quickly after load)
      updateHeight();

      // Click trigger (mobile + desktop)
      // Use capture phase so other theme scripts using stopImmediatePropagation() can't block this handler.
      trigger.addEventListener(
        'click',
        (e) => {
        e.preventDefault();
        toggle();
        },
        true
      );

      // Close on outside click
      document.addEventListener('click', (e) => {
        if (!isOpen) return;
        if (trigger.contains(e.target)) return;
        if (root.contains(e.target)) return;
        close();
      });

      // Close on Escape
      document.addEventListener('keydown', (e) => {
        if (!isOpen) return;
        if (e.key !== 'Escape') return;
        close();
        trigger.focus();
      });

      // Close when a mega menu is hovered/opened
      document.addEventListener('mouseover', (e) => {
        if (!isOpen) return;
        if (e.target.closest(SELECTORS.megaMenuTrigger)) close();
      });

      // Keep height in sync (results, empty state, etc.)
      if (window.ResizeObserver) {
        const ro = new ResizeObserver(() => {
          if (!isOpen) return;
          requestAnimationFrame(updateHeight);
        });
        ro.observe(body || panel);
      }

      if (input) {
        input.addEventListener('input', () => {
          if (!isOpen) return;
          requestAnimationFrame(updateHeight);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', init);
})();


